'use client'
import Header from '@/components/layout/main/header'
import Footer from '@/components/layout/main/footer/Footer'

export default function Layouts({ children }) {
  return (
    <div className="min-h-screen">
      <Header />
      <div
        className={`w-full min-h-[calc(100vh-var(--header-height-in-px))] flex flex-col justify-between`}
      >
        <div>{children}</div>
        <Footer />
      </div>
    </div>
  )
}
